"use strict";

// see https://www.w3.org/WAI/ARIA/apg/patterns/tabs/examples/tabs-automatic/

const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");
const ARIA_SELECTED = "aria-selected";
const IS_HIDDEN_CLASS = "is-hidden";

// load font via webpack asset/resource
// require("src/tokens/index.css");

class Tabs extends HTMLElement {
    constructor(template) {
        super(template);

        this.root = this.attachShadow({ mode: "open" });

        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);

        this.tabs = [];
        this.tabpanels = []
        this.initTabs();
        this.initTabpanels();
        this.selectInitialTab();


    }

    initTabs () {

        const tabsSlot = this.querySelectorAll("[slot=tab]");
        // const tabsSlot = [];
        const tabList = document.createElement("div");
        tabList.setAttribute("role", "tablist");
        for (const tabSlot of tabsSlot) {
            // tabs must be buttons
            const tab = document.createElement("button");
            tab.setAttribute("role", "tab");
            tab.innerHTML = tabSlot.innerHTML;
            if (tabSlot.hasAttribute(ARIA_SELECTED)) {
                tab.setAttribute(ARIA_SELECTED, tabSlot.getAttribute(ARIA_SELECTED));
            }
            if (tabSlot.hasAttribute("name")) {
                tab.setAttribute("name", tabSlot.getAttribute("name"));
            }
            if (tabSlot.hasAttribute("aria-controls")) {
                tab.setAttribute("aria-controls", tabSlot.getAttribute("aria-controls"));
            }

            if (tabSlot.hasAttribute("href")) {
                tab.setAttribute("href", tabSlot.getAttribute("href"));
            }
            tab.addEventListener("click", this.tabOnClick.bind(this));
            tab.addEventListener("keydown", this.tabOnKeydown.bind(this));
            this.tabs.push(tab);
            tabList.appendChild(tab);
            this.removeChild(tabSlot);
        }

        this.root.appendChild(tabList);

    }

    initTabpanels () {
        const tabpanelsSlot = this.querySelectorAll("[slot=tabpanel]");

        for (const tabpanelSlot of tabpanelsSlot) {
            const tabPanel = tabpanelSlot.cloneNode(true);
            tabPanel.setAttribute("role", "tabpanel");
            tabPanel.removeAttribute("slot");
            this.tabpanels.push(tabPanel);
            this.root.appendChild(tabPanel);
            this.removeChild(tabpanelSlot);
        }
    }

    selectInitialTab (tabName) {
        const selectedTab = tabName ?
            this.root.querySelectorAll(`[aria-controls=${tabName}]`) :
            this.root.querySelectorAll(`[${ARIA_SELECTED}=true]`);
        if (selectedTab.length === 0) {
            // activate the first tab by default
            this.setSelectedTab(this.tabs[0], false);
        } else {
            this.setSelectedTab(selectedTab[0], false);
        }
    }

    enableTab (tabName) {
        const currentTab = this.root.querySelector(`[aria-controls=${tabName}]`)

        for (let i = 0; i < this.tabs.length; i += 1) {
            const tab = this.tabs[i];
            if (currentTab === tab) {
                tab.classList.remove("disabled");
                const swiftrefIcon = tab.querySelector("swiftref-icon");
                if (swiftrefIcon)  {
                    tab.removeChild(swiftrefIcon);
                }
                return;
            }
        }
    }
    disableTab (tabName) {
        const currentTab = this.root.querySelector(`[aria-controls=${tabName}]`)
        for (let i = 0; i < this.tabs.length; i += 1) {
            const tab = this.tabs[i];
            if (currentTab === tab) {
                tab.classList.add("disabled");
                let swiftrefIcon = tab.querySelector("swiftref-icon");
                if (!swiftrefIcon) {
                    swiftrefIcon = document.createElement("swiftref-icon");
                    swiftrefIcon.setAttribute("kind", "lock");
                    tab.appendChild(swiftrefIcon);
                }
                return;
            }
        }
    }

    tabOnClick (event) {
        if (event.currentTarget.hasAttribute("href")) {
            window.location.href = event.currentTarget.getAttribute("href");
        } else {
            this.setSelectedTab(event.currentTarget);
        }
    }
    tabOnKeydown(event) {
        let target = event.currentTarget;
        let flag = false;

        switch (event.key) {
            case 'ArrowLeft':
                this.setSelectedToPreviousTab(target);
                flag = true;
                break;

            case 'ArrowRight':
                this.setSelectedToNextTab(target);
                flag = true;
                break;

            case 'Home':
                this.setSelectedTab(this.tabs[0]);
                flag = true;
                break;

            case 'End':
                this.setSelectedTab(this.tabs[this.tabs.length - 1]);
                flag = true;
                break;

            default:
                break;
        }

        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    setSelectedToPreviousTab(currentTab) {
        let index;

        if (currentTab === this.tabs[0]) {
            this.setSelectedTab(this.tabs[this.tabs.length - 1]);
        } else {
            index = this.tabs.indexOf(currentTab);
            this.setSelectedTab(this.tabs[index - 1]);
        }
    }

    setSelectedToNextTab(currentTab) {
        let index;

        if (currentTab === this.tabs[this.tabs.length - 1]) {
            this.setSelectedTab(this.tabs[0]);
        } else {
            index = this.tabs.indexOf(currentTab);
            this.setSelectedTab(this.tabs[index + 1]);
        }
    }
    setSelectedTab(target, setFocus) {
        if (target.classList.contains("disabled")) {
            return;
        }
        if (typeof setFocus !== 'boolean') {
            setFocus = true;
        }

        for (let i = 0; i < this.tabs.length; i += 1) {
            const tab = this.tabs[i];
            if (target === tab) {
                if (tab.getAttribute(ARIA_SELECTED) !== "true") {
                    tab.setAttribute(ARIA_SELECTED, "true");
                    tab.removeAttribute("tabindex");
                    if (this.tabpanels[i]) {
                        this.tabpanels[i].classList.remove(IS_HIDDEN_CLASS);
                    }
                    if (setFocus) {
                        tab.focus();
                    }
                    this.dispatchEvent(new CustomEvent("change_tab", {
                        detail: {
                            name: tab.getAttribute("aria-controls")
                        }
                    }))
                }
            } else {
                tab.setAttribute(ARIA_SELECTED, "false");
                tab.tabIndex = -1;
                if (this.tabpanels[i]) {
                    this.tabpanels[i].classList.add(IS_HIDDEN_CLASS);
                }
            }
        }

    }
}

window.customElements.define("swiftref-tabs", Tabs);

module.exports = Tabs;
